import Button from 'components/ui/Button';
import Modal from 'components/ui/Modal';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteSegmentRequest } from 'store/segments/segments.action';

const SegmentDeleteModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const onDelete = () => {
    if (id) {
      dispatch(deleteSegmentRequest(id));
      navigate('/segments');
    }
    onClose();
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Segment">
      <p className="text-muted-foreground mb-6">
        Are you sure you want to delete this segment? This action cannot be
        undone.
      </p>
      <div className="flex justify-end gap-3 pt-4 border-t border-border">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default SegmentDeleteModal;
